export default "__VITE_ASSET__B8LB9r9m__"